import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const withCredentialsInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  return next(request.clone({
    withCredentials: true,
    setHeaders: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }));
};
